import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import "./UserSelect.css"
import React, {useEffect, useState} from "react";
import RootState from "../../../redux/states/root.state";
import { CircularProgress, Pagination, Button, TextField, Radio, FormControlLabel, Link, List, ListItem, ListItemButton, ListItemText, ListItemIcon, Chip, Box, Typography, RadioGroup } from "@mui/material";
import { fetchRoleUsers } from "../../../redux/actions/roles.actions";
import {fetchCorporateUsers, fetchDealershipStaff} from "../../../redux/actions/dealership.actions";
import {useNavigate} from "react-router-dom";

interface UserSelectProps {
    setSelectedUser: any;
    selectedUser: any;
}

const SingleSelectUserRole: React.FC<UserSelectProps> = ({ setSelectedUser, selectedUser }) => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const {data:users,meta,loading} = useSelector((state: RootState) => state.roleUsers);
    const [pageNumber, setPageNumber] = useState(1);
    const [email, setEmail] = useState(``);
    const [emailQuery, setEmailQuery] = useState<any>(null);

    useEffect(() => {
        let page = `page=${pageNumber}`;
        if (emailQuery) {
            page += `&email=${emailQuery}`
        }
        dispatch(fetchCorporateUsers(page))
    }, [dispatch,pageNumber, emailQuery]);

  return (
    <>
        <div className="user-search-container">
            <TextField type="search" placeholder="Search email..." onChange={(e)=>setEmail(e.target.value)} size="small" fullWidth/>
            <Button type="button" variant="contained" onClick={()=>setEmailQuery(email)} size="small">Search</Button>
        </div>

    { loading ?
        <div className="no-users"><CircularProgress size={"24px"}/></div>
    :
        users.length>0 ?
            <div className="select-container">
            <RadioGroup
                value={selectedUser?.id || 'none'}
                onChange={(e) => {
                    if (e.target.value === 'none') {
                        setSelectedUser('none');
                    } else {
                        const user = users.find(u => u.id === e.target.value);
                        if (user) setSelectedUser(user);
                    }
                }}
            >
                <List 
                    dense
                    sx={{
                        maxHeight: 200,
                        overflow: 'auto',
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'rgba(0,0,0,0.1)',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.3)',
                            borderRadius: '4px',
                            '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.5)',
                            },
                        },
                    }}
                >
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={() => setSelectedUser('none')}
                            selected={selectedUser === null}
                            sx={{ borderRadius: 1 }}
                        >
                            <ListItemIcon>
                                <Radio value="none" size="small"/>
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="body2">
                                        None
                                    </Typography>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                    {users.map((user: any) => (
                        <ListItem key={user.id} disablePadding>
                            <ListItemButton
                                onClick={() => setSelectedUser(user)}
                                selected={selectedUser?.id === user?.id}
                                sx={{ borderRadius: 1 }}
                            >
                                <ListItemIcon>
                                    <Radio value={user.id} size="small"/>
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <Chip 
                                                label={user?.roles[0]?.name ?? 'customer'} 
                                                size="small" 
                                                color="primary" 
                                                variant="outlined"
                                            />
                                            <Typography variant="body2">
                                                {user?.name !== '' ? `${user?.name} (${user?.email})` : user?.email}
                                            </Typography>
                                        </Box>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </RadioGroup>
                {meta?.last_page>1 && <Pagination
                    count={meta?.last_page}
                    size="small"
                    onChange={(e,page)=>setPageNumber(page)}
                    page={pageNumber}
                    showLastButton
                    showFirstButton
                    disabled={meta?.last_page===1}
                />}
            </div>
            :
            <div className="no-users">
                <p>No users found.</p>
                <Link
                    href="/users"
                    onClick={e => {
                        e.preventDefault();
                        navigate('/users');
                    }}>View all users</Link>
            </div>
    }
    </>
  );
};

export default SingleSelectUserRole;
